import { MatDialog } from "@angular/material/dialog";
import { firstValueFrom } from "rxjs";
import { CbtaModalComponent } from "../components/cbta-modal/cbta-modal.component";

export type ConfirmationDialogOptions = {
	title: string;
	content: string;
	confirmText?: string;
	cancelText?: string;
	panelClass?: string;
	height?: string;
	width?: string;
};

export async function openConfirmationDialog(
	dialog: MatDialog,
	options: ConfirmationDialogOptions,
): Promise<boolean> {
	const dialogRef = dialog.open(CbtaModalComponent, {
		panelClass: options.panelClass ?? "confirmation-modal",
		height: options.height ?? "200px",
		width: options.width ?? "380px",
		hasBackdrop: true,
		data: {
			modalTitle: options.title,
			modalContent: options.content,
			modalBtnConfirmText: options.confirmText ?? "Yes",
			modalBtnCancelText: options.cancelText ?? "No",
		},
	});

	const result = await firstValueFrom(dialogRef.afterClosed());
	return !!(result && result.close);
}

export async function confirmSendToCandidate(dialog: MatDialog): Promise<boolean> {
	return openConfirmationDialog(dialog, {
		title: "Send to Candidate",
		content: "Are you sure you want to send this assessment to the candidate for sign-off?",
		confirmText: "Send",
		cancelText: "Cancel",
	});
}

export async function confirmCompleteAssessment(dialog: MatDialog): Promise<boolean> {
	return openConfirmationDialog(dialog, {
		title: "Complete Assessment",
		content: "Are you sure you want to complete this assessment? This action cannot be undone.",
		confirmText: "Complete",
		cancelText: "Cancel",
	});
}

export async function confirmLeaveUnsavedChanges(dialog: MatDialog): Promise<boolean> {
	return openConfirmationDialog(dialog, {
		title: "Unsaved Changes",
		content: "You have unsaved changes. Are you sure you want to leave this page?",
		confirmText: "Leave",
		cancelText: "Stay",
	});
}
